import { IconButton } from '@mui/material';
import { useState } from 'react';
import { useNotesContext } from '../hooks/useNotesContext';
import { TNoteMessage } from '../types';
import { Menu, MenuItem } from './ui/StyledMenu';
import { useNotesStore } from '../stores/notes.store';

type Props = {
  message: TNoteMessage;
  onDeleteSuccess?: () => void;
};

export const EditMenu = ({ message, onDeleteSuccess }: Props) => {
  const { setMediaUrls, setCurrentAction, setNoteToEdit } = useNotesContext();

  const selectedNote = useNotesStore((state) => state.selectedNote);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const isMenuOpen = Boolean(anchorEl);

  const openMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMediaUrls([]);
  };

  const handleDelete = () => {
    setAnchorEl(null);
    setCurrentAction?.({
      type: 'delete',
      note: selectedNote,
      message: message.isMainMessage ? null : message,
      onSuccess: () => {
        onDeleteSuccess?.();
      },
    });
  };

  const handleEdit = () => {
    setAnchorEl(null);
    setNoteToEdit({ note: selectedNote, message });
    setMediaUrls(message.mediaUrls.map((url) => ({ src: url, flaggedToDelete: false })));
  };

  return (
    <>
      <IconButton
        onClick={(e) => openMenu(e)}
        id={`message-button-${message.id}`}
        aria-controls={isMenuOpen ? `message-menu-${message.id}` : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
        sx={{ width: '24px', height: '24px' }}
      >
        <i
          className="fa-solid fa-ellipsis-vertical"
          style={message.isMainMessage ? { fontSize: '20px', color: '#101828' } : undefined}
        />
      </IconButton>
      <Menu
        id={`message-menu-${message.id}`}
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': `message-button-${message.id}`,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiPaper-root': {
            width: '120px',
          },
        }}
      >
        <MenuItem id={message.id.toString()} onClick={handleDelete}>
          Delete
        </MenuItem>

        {selectedNote?.format !== 'SAP' && <MenuItem onClick={handleEdit}>Edit</MenuItem>}
      </Menu>
    </>
  );
};
